import React from 'react';
import { CollectionCard } from '../components/ui/CollectionCard';
import { BrandButton } from '../components/ui/BrandButton';
import { ScrollReveal } from '../components/ui/ScrollReveal';
export function CollectionsPage() {
  return <div className="flex flex-col w-full bg-[#FFF8F0]" data-id="element-254">
      {/* Hero */}
      <section className="pt-32 pb-20 bg-gradient-to-b from-[#6B1D4A] to-[#4A1433] text-center px-4" data-id="element-255">
        <ScrollReveal data-id="element-256">
          <h1 className="font-heading text-5xl md:text-6xl font-bold text-[#FFF8F0] mb-6" data-id="element-257">
            Our Collections
          </h1>
          <p className="font-body text-lg md:text-xl text-[#F8C8DC] max-w-2xl mx-auto" data-id="element-258">
            Timeless chains, soft pearls, and effortless layers — designed to
            wear on repeat.
          </p>
        </ScrollReveal>
      </section>

      {/* Collections Grid */}
      <section className="py-20 md:py-32" data-id="element-259">
        <div className="container mx-auto px-4 md:px-8" data-id="element-260">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-6xl mx-auto" data-id="element-261">
            <ScrollReveal direction="up" delay={100} className="h-full" data-id="element-262">
              <CollectionCard name="The Butter Basics" tagline="Your forever, signature collection" description="Effortless, clean, and elevated basics that form the foundation of any great stack." pieces={['Classic gold chain', 'Classic silver chain', 'Pearl strand', 'Mixed metal chain', 'Dainty clasp necklace', 'Slim gold choker', 'Pearl + chain hybrid']} priceRange="$38–$52 core pieces / $58–$68 hero pieces" imageLabel="Classic gold + silver chains laid flat" shopUrl="https://shop.butter-blonde.com/collections/basics" withStripe data-id="element-263" />
            </ScrollReveal>

            <ScrollReveal direction="up" delay={300} className="h-full" data-id="element-264">
              <CollectionCard name="Stacked in Butter" tagline="Your brand's personality lives here" description="Playful, customizable, cool-girl layering pieces designed to make a statement." pieces={['Short choker', 'Mid-length chain', 'Long layering necklace', 'Mixed metal clasp necklace', 'Pearl layer', 'Chain extender / charm add-on']} priceRange="$42–$55 individual / $110–$145 curated stack sets" imageLabel="Playful layered necklace stack on a neck" badge="Build your Butter Stack" shopUrl="https://shop.butter-blonde.com/collections/stacked" withStripe data-id="element-265" />
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-20 md:py-24" style={{
      background: 'repeating-linear-gradient(90deg, #F5D76E 0px, #F5D76E 20px, #F0CC50 20px, #F0CC50 40px)'
    }} data-id="element-266">
        <div className="container mx-auto px-4 text-center" data-id="element-267">
          <ScrollReveal data-id="element-268">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#2D1A1A] mb-8" data-id="element-269">
              Can't decide? Start with a curated stack set.
            </h2>
            <BrandButton href="https://shop.butter-blonde.com/collections/sets" external variant="butter" className="text-lg px-12" data-id="element-270">
              Shop Stack Sets
            </BrandButton>
          </ScrollReveal>
        </div>
      </section>
    </div>;
}